import React from 'react';
import assets from '../assets/assets';

const Pyramid = () => {
    const { pyramid } = assets();

    return (
        <section className="pt-0 mt-0">
            <div className="container position-relative pt-0 mt-0">
                <div className="row align-items-center mb-7">
                    <div className="col-12 col-lg-5 col-xxl-4 text-center text-lg-start">
                        <span className="ps-3 pe-3 mb-4 text-uppercase text-base-color fs-14 lh-42px fw-700 border-radius-100px bg-gradient-very-light-gray-transparent d-inline-block">
                            Simple process
                        </span>
                        <h3 className="text-dark-gray fw-700 ls-minus-2px mb-4">Understand the business process.</h3>
                        <div className="row row-cols-1" data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                            {/* Process Step Item */}
                            <div className="col-12 process-step-style-05 position-relative hover-box mb-4">
                                <div className="process-step-item d-flex">
                                    <div className="process-step-icon-wrap position-relative">
                                        <div className="process-step-icon d-flex justify-content-center align-items-center mx-auto rounded-circle h-60px w-60px fs-14 bg-light-red fw-700 position-relative">
                                            <span className="number position-relative z-index-1 text-dark-gray">01</span>
                                            <div className="box-overlay bg-base-color rounded-circle"></div>
                                        </div>
                                        <span className="progress-step-separator bg-dark-gray opacity-1"></span>
                                    </div>
                                    <div className="process-content ps-3 last-paragraph-no-margin mb-3">
                                        <span className="d-block fw-700 text-dark-gray mb-2 fs-18">Start market research</span>
                                        <p className="w-90 lg-w-100 lh-32">Lorem ipsum amet consectetur eiusmod tempor incididunt.</p>
                                    </div>
                                </div>
                            </div>

                            {/* Process Step Item */}
                            <div className="col-12 process-step-style-05 position-relative hover-box mb-4">
                                <div className="process-step-item d-flex">
                                    <div className="process-step-icon-wrap position-relative">
                                        <div className="process-step-icon d-flex justify-content-center align-items-center mx-auto rounded-circle h-60px w-60px fs-14 bg-light-red fw-700 position-relative">
                                            <span className="number position-relative z-index-1 text-dark-gray">02</span>
                                            <div className="box-overlay bg-base-color rounded-circle"></div>
                                        </div>
                                        <span className="progress-step-separator bg-dark-gray opacity-1"></span>
                                    </div>
                                    <div className="process-content ps-3 last-paragraph-no-margin mb-3">
                                        <span className="d-block fw-700 text-dark-gray mb-2 fs-18">Discussion of the idea</span>
                                        <p className="w-90 lg-w-100 lh-32">Lorem ipsum amet consectetur eiusmod tempor incididunt.</p>
                                    </div>
                                </div>
                            </div>

                            {/* Process Step Item */}
                            <div className="col-12 process-step-style-05 position-relative hover-box mb-4 xs-mb-4">
                                <div className="process-step-item d-flex">
                                    <div className="process-step-icon-wrap position-relative">
                                        <div className="process-step-icon d-flex justify-content-center align-items-center mx-auto rounded-circle h-60px w-60px fs-14 bg-light-red fw-700 position-relative">
                                            <span className="number position-relative z-index-1 text-dark-gray">03</span>
                                            <div className="box-overlay bg-base-color rounded-circle"></div>
                                        </div>
                                    </div>
                                    <div className="process-content ps-3 last-paragraph-no-margin">
                                        <span className="d-block fw-700 text-dark-gray mb-2 fs-18">Production planning</span>
                                        <p className="w-90 lg-w-100 lh-32">Lorem ipsum amet consectetur eiusmod tempor incididunt.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-lg-7 offset-xxl-1 position-relative md-mb-4 sm-mb-4" data-anime='{ "translateX": [0, 0], "opacity": [0,1], "duration": 1200, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad" }'>
                        <img className="position-relative z-index-9 top-4px img-fluid" alt="Pyramid" src={pyramid} />
                        <img className="absolute-middle-center xs-w-95 img-fluid" alt="Pyramid" src={pyramid} />
                        <img className="position-absolute top-50px left-0px xs-left-15px img-fluid" alt="" src="images/demo-corporate-05.png" style={{ display: 'none', visibility: 'hidden' }} />
                        <img className="position-absolute top-150px left-30 img-fluid" alt="" src="images/demo-corporate-06.png" style={{ display: 'none', visibility: 'hidden' }} />
                        <img className="position-absolute top-50px right-30 img-fluid" alt="" src="images/demo-corporate-07.png" style={{ display: 'none', visibility: 'hidden' }} />
                        <img className="position-absolute top-100px right-0px xs-right-15px img-fluid" alt="" src="images/demo-corporate-08.png" style={{ display: 'none', visibility: 'hidden' }} />
                    </div>
                </div>

                <div className="row justify-content-center align-items-center">
                    <div className="col-12 text-center align-items-center" data-anime='{ "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                        <div className="bg-base-color fw-700 text-white text-uppercase border-radius-30px ps-20px pe-20px fs-12 me-10px sm-m-5px d-inline-block align-middle">Hurray</div>
                        <div className="fs-18 fw-500 text-dark-gray d-inline-block align-middle">
                            Let's make something great work together. <a href="#" className="text-dark-gray text-decoration-line-bottom fw-700">Got a project in mind?</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Pyramid;
